import React from 'react';
import { FloatingButton, WhatsAppIcon, HoverText } from './style';

function WhatsAppButton() {
  const phoneNumber = "551151966625";
  const message = "Olá, encontrei vocês pelo site e gostaria de receber mais informações sobre os serviços.";
  
 
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
   
    <FloatingButton href={whatsappUrl} target="_blank" rel="noopener noreferrer">
      <HoverText>Precisa de ajuda?</HoverText>
      <WhatsAppIcon src="/icone/icone-whatsapp.png" alt="Fale conosco pelo WhatsApp" />
    </FloatingButton>
  );
}

export default WhatsAppButton;